import React, { Component } from "react";
import { Paper, Grid, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import { BulkEditDatePickerCustom } from "util/bulk-edit-input-elements/BulkEditDatePickerCustom";
import moment from "moment";
import DeselectableRadioGroup from "util/bulk-edit-input-elements/DeselectableRadioGroup";
import {
  bulkEditTextLength,
  bulkEditTextType,
  bulkEditOptionsType,
} from "redux/Types";
import BulkEditTextInput from "util/bulk-edit-input-elements/BulkEditTextInput";
import BulkEditCustomSelect from "util/bulk-edit-input-elements/BulkEditCustomSelect";
import CustomChipInput from "util/bulk-edit-input-elements/CustomChipInput";
import BulkEditKeywordInput from "util/bulk-edit-input-elements/BulkEditKeywordInput";

export class TracksSingleSpecificUpdates extends Component {
  render() {
    const {
      classes,

      bulkEditData: {
        editing,
        isTrackDataEmpty,
        job,
        job: { track_specific_updates },
        validationErrors: { track_specific_validation },
        posting: { busy, errors },
      },
      handleTrackValueChange,
      currentTrackId,
      loading,
      countries,
      origins,
      decades,
      vocals,
      handleTrackRefreshValues,
      editTrackAppendValues,
      trackLyrics,
      trackLibrarianNotes,
      trackTrackNotes,
      trackLyricsAppendFalse,
      trackLibrarianNotesAppendFalse,
      trackTrackNotesAppendFalse,
      handleTrackAddChip,
      handleTrackDeleteChip,
      handleKeywordChange,
    } = this.props;

    let specific_updates = null;
    let trackSpecificValidation = null;

    if (currentTrackId) {
      specific_updates = track_specific_updates
        ? track_specific_updates[currentTrackId]
        : null;
      trackSpecificValidation = track_specific_validation
        ? track_specific_validation[currentTrackId]
        : null;
    }

    var recordingYear = specific_updates &&
      specific_updates.org_sky_RecordingYear !==
      undefined
      ? specific_updates.org_sky_RecordingYear !==
        null
        ? specific_updates.org_sky_RecordingYear
        : null
      : editing &&
        editing.org_sky_RecordingYear !==
        undefined
        ? editing.org_sky_RecordingYear !== null
          ? editing.org_sky_RecordingYear
          : null
        : null;

    if (recordingYear) {
      recordingYear = moment(
        recordingYear,
        "YYYY"
      ).toDate();
    }

    return (
      <div>
        {loading && (
          <div className={classes.overlay}>
            <CircularProgress size={200} className={classes.bulkEditLoading} />
          </div>
        )}
        <>
          {!isTrackDataEmpty ? (
            <Paper className={classes.globalCreateBody}>
              <Grid container className={classes.globalCreateInput}>
                <div>
                  <div className={clsx(classes.globalCreateContentWrapper)}>
                    <Grid spacing={12}>
                      <Grid container>
                        <Grid item xs={4}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock forty",
                                specific_updates &&
                                  (specific_updates.trackTitle ||
                                    specific_updates.trackTitle == "") &&
                                  editing?.trackTitle !==
                                  specific_updates.trackTitle &&
                                  !(
                                    editing?.trackTitle == undefined &&
                                    specific_updates.trackTitle == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="trackTitle"
                                name="trackTitle"
                                title="Title"
                                isRequired={true}
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.trackTitle !== undefined
                                    ? specific_updates.trackTitle !== null
                                      ? specific_updates.trackTitle
                                      : ""
                                    : editing &&
                                      editing.trackTitle !== undefined
                                      ? editing.trackTitle !== null
                                        ? editing.trackTitle
                                        : ""
                                      : ""
                                }
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.trackTitle ||specific_updates.trackTitle == "") &&editing?.trackTitle !==specific_updates.trackTitle? false: true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("trackTitle")
                                }
                                errors={trackSpecificValidation || {}}
                              />
                            </div>
                            <div
                              className={clsx(
                                "singleBlock forty",
                                specific_updates &&
                                  (specific_updates.trackVersionTitle ||
                                    specific_updates.trackVersionTitle == "") &&
                                  editing?.trackVersionTitle !==
                                  specific_updates.trackVersionTitle &&
                                  !(
                                    editing?.trackVersionTitle == undefined &&
                                    specific_updates.trackVersionTitle == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="trackVersionTitle"
                                name="trackVersionTitle"
                                title="Version Title"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.trackVersionTitle !==
                                    undefined
                                    ? specific_updates.trackVersionTitle !==
                                      null
                                      ? specific_updates.trackVersionTitle
                                      : ""
                                    : editing &&
                                      editing.trackVersionTitle !== undefined
                                      ? editing.trackVersionTitle !== null
                                        ? editing.trackVersionTitle
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.trackVersionTitle ||specific_updates.trackVersionTitle == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("trackVersionTitle")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={8}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock sixty",
                                specific_updates &&
                                  specific_updates.composer?.length > 0 &&
                                  (editing?.composer?.length !==
                                    specific_updates.composer.length ||
                                    !editing.composer.every((value) =>
                                      specific_updates.composer.includes(value)
                                    ))
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <CustomChipInput
                                id="composer"
                                name="composer"
                                title="Composer"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                onAdd={(chip) =>
                                  handleTrackAddChip(chip, "composer")
                                }
                                onDelete={(chip) =>
                                  handleTrackDeleteChip(chip, "composer")
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.composer !== undefined
                                    ? specific_updates.composer !== null
                                      ? specific_updates.composer
                                      : []
                                    : editing && editing.composer !== undefined
                                      ? editing.composer !== null
                                        ? editing.composer
                                        : []
                                      : []
                                }
                              />
                            </div>
                            <div
                              className={clsx(
                                "singleBlock sixty",
                                specific_updates &&
                                  specific_updates.publisher?.length > 0 &&
                                  (editing?.publisher?.length !==
                                    specific_updates.publisher.length ||
                                    !editing.publisher.every((value) =>
                                      specific_updates.publisher.includes(value)
                                    ))
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <CustomChipInput
                                id="publisher"
                                name="publisher"
                                title="Publisher"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                onAdd={(chip) =>
                                  handleTrackAddChip(chip, "publisher")
                                }
                                onDelete={(chip) =>
                                  handleTrackDeleteChip(chip, "publisher")
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.publisher !== undefined
                                    ? specific_updates.publisher !== null
                                      ? specific_updates.publisher
                                      : []
                                    : editing && editing.publisher !== undefined
                                      ? editing.publisher !== null
                                        ? editing.publisher
                                        : []
                                      : []
                                }
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} spacing={12}>
                          <div
                            style={{ height: " 10px", display: "block" }}></div>
                        </Grid>
                        <Grid item xs={4}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  specific_updates.performer?.length > 0 &&
                                  (editing?.performer?.length !==
                                    specific_updates.performer.length ||
                                    !editing.performer.every((value) =>
                                      specific_updates.performer.includes(value)
                                    ))
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <CustomChipInput
                                id="performer"
                                name="performer"
                                title="Artist"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                onAdd={(chip) =>
                                  handleTrackAddChip(chip, "performer")
                                }
                                onDelete={(chip) =>
                                  handleTrackDeleteChip(chip, "performer")
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.performer !== undefined
                                    ? specific_updates.performer !== null
                                      ? specific_updates.performer
                                      : []
                                    : editing && editing.performer !== undefined
                                      ? editing.performer !== null
                                        ? editing.performer
                                        : []
                                      : []
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  specific_updates.recordLabel?.length > 0 &&
                                  (editing?.recordLabel?.length !==
                                    specific_updates.recordLabel.length ||
                                    !editing.recordLabel.every((value) =>
                                      specific_updates.recordLabel.includes(
                                        value
                                      )
                                    ))
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <CustomChipInput
                                id="recordLabel"
                                name="recordLabel"
                                title="Label"
                                titleClass={classes.bulkLabelRight}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                onAdd={(chip) =>
                                  handleTrackAddChip(chip, "recordLabel")
                                }
                                onDelete={(chip) =>
                                  handleTrackDeleteChip(chip, "recordLabel")
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.recordLabel !== undefined
                                    ? specific_updates.recordLabel !== null
                                      ? specific_updates.recordLabel
                                      : []
                                    : editing &&
                                      editing.recordLabel !== undefined
                                      ? editing.recordLabel !== null
                                        ? editing.recordLabel
                                        : []
                                      : []
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  specific_updates.styles?.length > 0 &&
                                  (editing?.styles?.length !==
                                    specific_updates.styles.length ||
                                    !editing.styles.every((value) =>
                                      specific_updates.styles.includes(value)
                                    ))
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <CustomChipInput
                                id="styles"
                                name="styles"
                                title="Style"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                onAdd={(chip) =>
                                  handleTrackAddChip(chip, "styles")
                                }
                                onDelete={(chip) =>
                                  handleTrackDeleteChip(chip, "styles")
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.styles !== undefined
                                    ? specific_updates.styles !== null
                                      ? specific_updates.styles
                                      : []
                                    : editing && editing.styles !== undefined
                                      ? editing.styles !== null
                                        ? editing.styles
                                        : []
                                      : []
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_Country ||
                                    specific_updates.org_sky_Country == "") &&
                                  editing?.org_sky_Country !==
                                  specific_updates.org_sky_Country &&
                                  !(
                                    editing?.org_sky_Country == undefined &&
                                    specific_updates.org_sky_Country == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="org_sky_Country"
                                name="org_sky_Country"
                                title="Country"
                                titleClass={classes.bulkLabelRight}
                                disableUnderline
                                options={countries}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_Country !== undefined
                                    ? specific_updates.org_sky_Country !== null
                                      ? specific_updates.org_sky_Country
                                      : ""
                                    : editing &&
                                      editing.org_sky_Country !== undefined
                                      ? editing.org_sky_Country !== null
                                        ? editing.org_sky_Country
                                        : ""
                                      : ""
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_Country ||specific_updates.org_sky_Country == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_Country")
                                }
                                errors={trackSpecificValidation}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.org_sky_Country
                                    ? classes.customError
                                    : {}
                                )}
                              />
                              {errors && errors.org_sky_Country && (
                                <span
                                  role="alert"
                                  className={classes.appbarHideLabel}>
                                  {errors.org_sky_Country}
                                </span>
                              )}
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_Area ||
                                    specific_updates.org_sky_Area == "") &&
                                  editing?.org_sky_Area !==
                                  specific_updates.org_sky_Area &&
                                  !(
                                    editing?.org_sky_Area == undefined &&
                                    specific_updates.org_sky_Area == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_Area"
                                name="org_sky_Area"
                                title="Area"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_Area !== undefined
                                    ? specific_updates.org_sky_Area !== null
                                      ? specific_updates.org_sky_Area
                                      : ""
                                    : editing &&
                                      editing.org_sky_Area !== undefined
                                      ? editing.org_sky_Area !== null
                                        ? editing.org_sky_Area
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_Area ||specific_updates.org_sky_Area == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_Area")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (parseInt(
                                    specific_updates.org_sky_RecordingYear,
                                    10
                                  ) ||
                                    parseInt(
                                      specific_updates.org_sky_RecordingYear,
                                      10
                                    ) == "") &&
                                  parseInt(
                                    editing?.org_sky_RecordingYear,
                                    10
                                  ) !==
                                  parseInt(
                                    specific_updates.org_sky_RecordingYear,
                                    10
                                  ) &&
                                  !(
                                    parseInt(
                                      editing?.org_sky_RecordingYear,
                                      10
                                    ) == undefined &&
                                    parseInt(
                                      specific_updates.org_sky_RecordingYear,
                                      10
                                    ) == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditDatePickerCustom
                                name="org_sky_RecordingYear"
                                id="org_sky_RecordingYear"
                                title="Year"
                                titleClass={classes.bulkLabelRight}
                                arialabel="Year"
                                variant="inline"
                                format="yyyy"
                                margin="normal"
                                yearView={true}
                                classes={classes}
                                className={
                                  classes.tableFilterDateInputWithClear
                                }
                                autoOk={true}
                                inputProps={{
                                  "aria-label": "Recording Year",
                                }}
                                clearValueButton={true}
                                value={recordingYear}
                                onChange={(event) => {
                                  handleTrackValueChange({
                                    target: {
                                      name: "org_sky_RecordingYear",
                                      type: "datetime",
                                      value: event
                                        ? moment(event).format("yyyy")
                                        : "",
                                    },
                                  });
                                }}
                                onClearValueEvent={(event) => {
                                  handleTrackValueChange({
                                    target: {
                                      name: "org_sky_RecordingYear",
                                      type: "datetime",
                                      value: null,
                                    },
                                  });
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_RecordingYear ||specific_updates.org_sky_RecordingYear =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_RecordingYear"
                                  )
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_Decade ||
                                    specific_updates.org_sky_Decade == "") &&
                                  editing?.org_sky_Decade !==
                                  specific_updates.org_sky_Decade &&
                                  !(
                                    editing?.org_sky_Decade == undefined &&
                                    specific_updates.org_sky_Decade == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="org_sky_Decade"
                                name="org_sky_Decade"
                                title="Decade / Era"
                                titleClass={classes.bulkLabelRight}
                                disableUnderline
                                options={decades}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_Decade !== undefined
                                    ? specific_updates.org_sky_Decade !== null
                                      ? specific_updates.org_sky_Decade
                                      : ""
                                    : editing &&
                                      editing.org_sky_Decade !== undefined
                                      ? editing.org_sky_Decade !== null
                                        ? editing.org_sky_Decade
                                        : ""
                                      : ""
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_Decade ||specific_updates.org_sky_Decade == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_Decade")
                                }
                                errors={trackSpecificValidation}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.org_sky_Decade
                                    ? classes.customError
                                    : {}
                                )}
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={8}>
                           <Grid container spacing={0}>
                        <Grid item xs={6}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.prs ||
                                    specific_updates.prs == "") &&
                                  editing?.prs !== specific_updates.prs &&
                                  !(
                                    editing?.prs == undefined &&
                                    specific_updates.prs == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="prs"
                                name="prs"
                                title="Tunecode"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.prs !== undefined
                                    ? specific_updates.prs !== null
                                      ? specific_updates.prs
                                      : ""
                                    : editing && editing.prs !== undefined
                                      ? editing.prs !== null
                                        ? editing.prs
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.prs ||specific_updates.prs == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("prs")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.musicOrigin ||
                                    specific_updates.musicOrigin == "") &&
                                  editing?.musicOrigin !==
                                  specific_updates.musicOrigin &&
                                  !(
                                    editing?.musicOrigin == undefined &&
                                    specific_updates.musicOrigin == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="musicOrigin"
                                name="musicOrigin"
                                title="Origin"
                                titleClass={classes.bulkLabelRight}
                                disableUnderline
                                options={origins}
                                value={
                                  specific_updates &&
                                    specific_updates.musicOrigin !== undefined
                                    ? specific_updates.musicOrigin !== null
                                      ? specific_updates.musicOrigin
                                      : ""
                                    : editing &&
                                      editing.musicOrigin !== undefined
                                      ? editing.musicOrigin !== null
                                        ? editing.musicOrigin
                                        : ""
                                      : ""
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.musicOrigin ||specific_updates.musicOrigin == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("musicOrigin")
                                }
                                errors={trackSpecificValidation}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.musicOrigin ? classes.customError : {}
                                )}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_Vocal ||
                                    specific_updates.org_sky_Vocal == "") &&
                                  editing?.org_sky_Vocal !==
                                  specific_updates.org_sky_Vocal &&
                                  !(
                                    editing?.org_sky_Vocal == undefined &&
                                    specific_updates.org_sky_Vocal == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="org_sky_Vocal"
                                name="org_sky_Vocal"
                                title="Vocal"
                                titleClass={classes.bulkLabelRight}
                                disableUnderline
                                options={vocals}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_Vocal !== undefined
                                    ? specific_updates.org_sky_Vocal !== null
                                      ? specific_updates.org_sky_Vocal
                                      : ""
                                    : editing &&
                                      editing.org_sky_Vocal !== undefined
                                      ? editing.org_sky_Vocal !== null
                                        ? editing.org_sky_Vocal
                                        : ""
                                      : ""
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_Vocal ||specific_updates.org_sky_Vocal == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_Vocal")
                                }
                                errors={trackSpecificValidation}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.org_sky_Vocal
                                    ? classes.customError
                                    : {}
                                )}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.position ||
                                    specific_updates.position == "") &&
                                  editing?.position !==
                                  specific_updates.position &&
                                  !(
                                    editing?.position == undefined &&
                                    specific_updates.position == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="position"
                                name="position"
                                title="Track No"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.NUMBER}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.position !== undefined
                                    ? specific_updates.position !== null
                                      ? specific_updates.position
                                      : ""
                                    : editing && editing.position !== undefined
                                      ? editing.position !== null
                                        ? editing.position
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.position ||specific_updates.position == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("position")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>
                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.prodDiscNr ||
                                    specific_updates.prodDiscNr == "") &&
                                  editing?.prodDiscNr !==
                                  specific_updates.prodDiscNr &&
                                  !(
                                    editing?.prodDiscNr == undefined &&
                                    specific_updates.prodDiscNr == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="prodDiscNr"
                                name="prodDiscNr"
                                title="Disk No"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.NUMBER}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.prodDiscNr !== undefined
                                    ? specific_updates.prodDiscNr !== null
                                      ? specific_updates.prodDiscNr
                                      : ""
                                    : editing &&
                                      editing.prodDiscNr !== undefined
                                      ? editing.prodDiscNr !== null
                                        ? editing.prodDiscNr
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.prodDiscNr ||specific_updates.prodDiscNr == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("prodDiscNr")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.tempo ||
                                    specific_updates.tempo == "") &&
                                  editing?.tempo !== specific_updates.tempo &&
                                  !(
                                    editing?.tempo == undefined &&
                                    specific_updates.tempo == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="tempo"
                                name="tempo"
                                title="Tempo"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.NUMBER}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.tempo !== undefined
                                    ? specific_updates.tempo !== null
                                      ? specific_updates.tempo
                                      : ""
                                    : editing && editing.tempo !== undefined
                                      ? editing.tempo !== null
                                        ? editing.tempo
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.tempo ||specific_updates.tempo == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("tempo")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.numBpm ||
                                    specific_updates.numBpm == "") &&
                                  editing?.numBpm !== specific_updates.numBpm &&
                                  !(
                                    editing?.numBpm == undefined &&
                                    specific_updates.numBpm == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="numBpm"
                                name="numBpm"
                                title="BPM"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.NUMBER}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.numBpm !== undefined
                                    ? specific_updates.numBpm !== null
                                      ? specific_updates.numBpm
                                      : ""
                                    : editing && editing.numBpm !== undefined
                                      ? editing.numBpm !== null
                                        ? editing.numBpm
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.numBpm ||specific_updates.numBpm == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("numBpm")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>


                           
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_SingleChartPosition ||
                                    specific_updates.org_sky_SingleChartPosition ==
                                    "") &&
                                  Number(
                                    editing?.org_sky_SingleChartPosition
                                  ) !==
                                  Number(
                                    specific_updates.org_sky_SingleChartPosition
                                  ) &&
                                  !(
                                    editing?.org_sky_SingleChartPosition ==
                                    undefined &&
                                    specific_updates.org_sky_SingleChartPosition ==
                                    ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_SingleChartPosition"
                                name="org_sky_SingleChartPosition"
                                title="Single Chart Pos"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.NUMBER}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleChange={(event) =>
                                  handleTrackValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_SingleChartPosition !==
                                    undefined
                                    ? specific_updates.org_sky_SingleChartPosition !==
                                      null
                                      ? specific_updates.org_sky_SingleChartPosition
                                      : ""
                                    : editing &&
                                      editing.org_sky_SingleChartPosition !==
                                      undefined
                                      ? editing.org_sky_SingleChartPosition !==
                                        null
                                        ? editing.org_sky_SingleChartPosition
                                        : ""
                                      : ""
                                }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_SingleChartPosition ||specific_updates.org_sky_SingleChartPosition =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_SingleChartPosition"
                                  )
                                }
                                errors={trackSpecificValidation}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates.org_sky_SingleReleaseDate ||
                                    specific_updates.org_sky_SingleReleaseDate ==
                                    "") &&
                                  editing?.org_sky_SingleReleaseDate !==
                                  specific_updates.org_sky_SingleReleaseDate &&
                                  !(
                                    editing?.org_sky_SingleReleaseDate ==
                                    undefined &&
                                    specific_updates.org_sky_SingleReleaseDate ==
                                    ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditDatePickerCustom
                                name="org_sky_SingleReleaseDate"
                                title="Single Release Date"
                                titleClass={classes.bulkLabelRight}
                                arialabel="Single Release Date"
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                // minDate={new Date(Date.now())}
                                classes={classes}
                                className={
                                  classes.tableFilterDateInputWithClear
                                }
                                autoOk={true}
                                inputProps={{
                                  "aria-label": "Single Release Date",
                                }}
                                clearValueButton={true}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_SingleReleaseDate !==
                                    undefined
                                    ? specific_updates.org_sky_SingleReleaseDate !==
                                      null
                                      ? specific_updates.org_sky_SingleReleaseDate
                                      : null
                                    : editing &&
                                      editing.org_sky_SingleReleaseDate !==
                                      undefined
                                      ? editing.org_sky_SingleReleaseDate !== null
                                        ? editing.org_sky_SingleReleaseDate
                                        : null
                                      : null
                                }
                                onChange={(event) => {
                                  handleTrackValueChange({
                                    target: {
                                      name: "org_sky_SingleReleaseDate",
                                      type: "datetime",
                                      value: event
                                        ? moment(event).format("yyyy-MM-DD")
                                        : "",
                                    },
                                  });
                                }}
                                onClearValueEvent={(event) => {
                                  handleTrackValueChange({
                                    target: {
                                      name: "org_sky_SingleReleaseDate",
                                      type: "datetime",
                                      value: null,
                                    },
                                  });
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_SingleReleaseDate ||specific_updates.org_sky_SingleReleaseDate =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_SingleReleaseDate"
                                  )
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates?.org_sky_IsSingleRelease ===
                                    true ||
                                    specific_updates?.org_sky_IsSingleRelease ===
                                    false) &&
                                  editing?.org_sky_IsSingleRelease !==
                                  specific_updates.org_sky_IsSingleRelease
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <DeselectableRadioGroup
                                ariaLabel="org_sky_IsSingleRelease"
                                name="org_sky_IsSingleRelease"
                                title="Single Release"
                                titleClass={classes.bulkLabelRight}
                                options={bulkEditOptionsType}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_IsSingleRelease !==
                                    undefined
                                    ? specific_updates.org_sky_IsSingleRelease !==
                                      null
                                      ? specific_updates.org_sky_IsSingleRelease
                                      : ""
                                    : editing &&
                                      editing.org_sky_IsSingleRelease !==
                                      undefined
                                      ? editing.org_sky_IsSingleRelease !== null
                                        ? editing.org_sky_IsSingleRelease
                                        : ""
                                      : null
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_IsSingleRelease ||specific_updates.org_sky_IsSingleRelease =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_IsSingleRelease"
                                  )
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates?.org_sky_DownloadAvailable ===
                                    true ||
                                    specific_updates?.org_sky_DownloadAvailable ===
                                    false) &&
                                  editing?.org_sky_DownloadAvailable !==
                                  specific_updates.org_sky_DownloadAvailable
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <DeselectableRadioGroup
                                ariaLabel="org_sky_DownloadAvailable"
                                name="org_sky_DownloadAvailable"
                                title="Download Allowed"
                                titleClass={classes.bulkLabelRight}
                                options={bulkEditOptionsType}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_DownloadAvailable !==
                                    undefined
                                    ? specific_updates.org_sky_DownloadAvailable !==
                                      null
                                      ? specific_updates.org_sky_DownloadAvailable
                                      : ""
                                    : editing &&
                                      editing.org_sky_DownloadAvailable !==
                                      undefined
                                      ? editing.org_sky_DownloadAvailable !== null
                                        ? editing.org_sky_DownloadAvailable
                                        : ""
                                      : null
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_DownloadAvailable ||specific_updates.org_sky_DownloadAvailable =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_DownloadAvailable"
                                  )
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates?.org_sky_IsLibraryRecommended ===
                                    true ||
                                    specific_updates?.org_sky_IsLibraryRecommended ===
                                    false) &&
                                  Number(
                                    editing?.org_sky_IsLibraryRecommended
                                  ) !==
                                  Number(
                                    specific_updates?.org_sky_IsLibraryRecommended
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <DeselectableRadioGroup
                                ariaLabel="org_sky_IsLibraryRecommended"
                                name="org_sky_IsLibraryRecommended"
                                title="Library Recommended"
                                titleClass={classes.bulkLabelRight}
                                options={bulkEditOptionsType}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_IsLibraryRecommended !==
                                    undefined
                                    ? specific_updates.org_sky_IsLibraryRecommended !==
                                      null
                                      ? specific_updates.org_sky_IsLibraryRecommended
                                      : ""
                                    : editing &&
                                      editing.org_sky_IsLibraryRecommended !==
                                      undefined
                                      ? editing.org_sky_IsLibraryRecommended !==
                                        null
                                        ? editing.org_sky_IsLibraryRecommended
                                        : ""
                                      : null
                                }
                                onChange={handleTrackValueChange}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_IsLibraryRecommended ||specific_updates.org_sky_IsLibraryRecommended =="")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues(
                                    "org_sky_IsLibraryRecommended"
                                  )
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates?.org_sky_PPL === true ||
                                    specific_updates?.org_sky_PPL === false) &&
                                  editing?.org_sky_PPL !==
                                  specific_updates.org_sky_PPL
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <DeselectableRadioGroup
                                ariaLabel="org_sky_PPL"
                                name="org_sky_PPL"
                                title="Non-PPL"
                                titleClass={classes.bulkLabelRight}
                                options={bulkEditOptionsType}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_PPL !== undefined
                                    ? specific_updates.org_sky_PPL !== null
                                      ? (specific_updates.org_sky_PPL == true || specific_updates.org_sky_PPL == 1) ? false
                                        : (specific_updates.org_sky_PPL == false || specific_updates.org_sky_PPL == 0) ? true : null
                                      : ""
                                    : editing && editing.pplStatusMigrated != true ? null :
                                      editing && editing.org_sky_PPL !== undefined
                                      ? editing.org_sky_PPL !== null
                                        ? (editing.org_sky_PPL == true || editing.org_sky_PPL == 1) ? false
                                          : (editing.org_sky_PPL == false || editing.org_sky_PPL == 0) ? true : null
                                        : ""
                                      : null
                                }
                                onChange={(event) => {
                                  var changes = {
                                    target: {
                                      name: event?.target?.name, value: (event?.target?.value != undefined
                                        && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null
                                    }
                                  };
                                  handleTrackValueChange(changes);
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_PPL ||specific_updates.org_sky_PPL == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_PPL")
                                }
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                specific_updates &&
                                  (specific_updates?.org_sky_MCPS === true ||
                                    specific_updates?.org_sky_MCPS === false) &&
                                  editing?.org_sky_MCPS !==
                                  specific_updates.org_sky_MCPS
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <DeselectableRadioGroup
                                ariaLabel="org_sky_MCPS"
                                name="org_sky_MCPS"
                                title="Non-MCPS"
                                titleClass={classes.bulkLabelRight}
                                options={bulkEditOptionsType}
                                classes={classes}
                                value={
                                  specific_updates &&
                                    specific_updates.org_sky_MCPS !== undefined
                                    ? specific_updates.org_sky_MCPS !== null
                                      ? (specific_updates.org_sky_MCPS == true || specific_updates.org_sky_MCPS == 1) ? false
                                        : (specific_updates.org_sky_MCPS == false || specific_updates.org_sky_MCPS == 0) ? true : null
                                      : ""
                                    : editing &&
                                      editing.org_sky_MCPS !== undefined
                                      ? editing.org_sky_MCPS !== null
                                        ? (editing.org_sky_MCPS == true || editing.org_sky_MCPS == 1) ? false
                                          : (editing.org_sky_MCPS == false || editing.org_sky_MCPS == 0) ? true : null
                                        : ""
                                      : null
                                }
                                onChange={(event) => {
                                  var changes = {
                                    target: {
                                      name: event?.target?.name, value: (event?.target?.value != undefined
                                        && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null
                                    }
                                  };
                                  handleTrackValueChange(changes);
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.org_sky_MCPS ||specific_updates.org_sky_MCPS == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("org_sky_MCPS")
                                }
                              />
                            </div>
                          </div>
                        </Grid>
                        </Grid>
                         
                                 <Grid item xs={12}> <div
                              className={clsx(
                                "singleBlock keywordTags",
                                specific_updates &&
                                  (specific_updates.tempo ||
                                    specific_updates.tempo == "") &&
                                  editing?.tempo !== specific_updates.tempo &&
                                  !(
                                    editing?.tempo == undefined &&
                                    specific_updates.tempo == ""
                                  )
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditKeywordInput
                                id="keywords"
                                name="keywords"
                                title="Keywords"
                                titleClass={classes.bulkLabelRight}
                                type={bulkEditTextType.TEXT}
                                maxLength={bulkEditTextLength.SMALL}
                                classes={classes}
                                handleKeywordChange={(trackId, keywords) =>
                                  handleKeywordChange(
                                    trackId,
                                    keywords
                                  )
                                }

                                specificUpdates={specific_updates}
                                editing={editing}
                                // value={
                                //   specific_updates &&
                                //   specific_updates.keywords !== undefined
                                //     ? specific_updates.keywords !== null
                                //       ? specific_updates.keywords
                                //       : ""
                                //     : editing && editing.keywords !== undefined
                                //     ? editing.keywords !== null
                                //       ? editing.keywords
                                //       : ""
                                //     : ""
                                // }
                                refreshDisabled={true}
                                //refreshDisabled={specific_updates &&(specific_updates.keywords ||specific_updates.keywords == "")?false:true}
                                refreshOnClick={() =>
                                  handleTrackRefreshValues("keywords")
                                }
                                errors={trackSpecificValidation}
                              />
                            </div></Grid>
 </Grid>

                        {editTrackAppendValues ? (
                          <Grid item xs={6}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.trackNotes ||
                                      specific_updates.trackNotes == "") &&
                                    editing?.trackNotes !==
                                    specific_updates.trackNotes &&
                                    !(
                                      editing?.trackNotes == undefined &&
                                      specific_updates.trackNotes == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="trackNotes"
                                  name="trackNotes"
                                  title="Notes"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  multiline
                                  maxLength={bulkEditTextLength.LARGE}
                                  isAppend={true}
                                  rows={6}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    editTrackAppendValues
                                      ? trackTrackNotes !== null
                                        ? trackTrackNotes
                                        : ""
                                      : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.trackNotes ||specific_updates.trackNotes == "")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues("trackNotes")
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        ) : (
                          <Grid item xs={6}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.trackNotes ||
                                      specific_updates.trackNotes == "") &&
                                    editing?.trackNotes !==
                                    specific_updates.trackNotes &&
                                    !(
                                      editing?.trackNotes == undefined &&
                                      specific_updates.trackNotes == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="trackNotes"
                                  name="trackNotes"
                                  title="Notes"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  multiline
                                  maxLength={bulkEditTextLength.LARGE}
                                  isAppend={true}
                                  rows={6}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    !editTrackAppendValues
                                      ? trackTrackNotesAppendFalse !== null
                                        ? trackTrackNotesAppendFalse
                                        : ""
                                      : editing &&
                                        editing.trackNotes !== undefined
                                        ? editing.trackNotes !== null
                                          ? editing.trackNotes
                                          : ""
                                        : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.trackNotes ||specific_updates.trackNotes == "")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues("trackNotes")
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        )}
                        
                        {editTrackAppendValues ? (
                          <Grid item xs={6}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.org_sky_LibrarianNotes ||
                                      specific_updates.org_sky_LibrarianNotes ==
                                      "") &&
                                    editing?.org_sky_LibrarianNotes !==
                                    specific_updates.org_sky_LibrarianNotes &&
                                    !(
                                      editing?.org_sky_LibrarianNotes ==
                                      undefined &&
                                      specific_updates.org_sky_LibrarianNotes ==
                                      ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_LibrarianNotes"
                                  name="org_sky_LibrarianNotes"
                                  title="Librarian Notes"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  maxLength={bulkEditTextLength.LARGE}
                                  isAppend={true}
                                  multiline
                                  rows={6}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    editTrackAppendValues
                                      ? trackLibrarianNotes !== null
                                        ? trackLibrarianNotes
                                        : ""
                                      : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_LibrarianNotes ||specific_updates.org_sky_LibrarianNotes =="")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues(
                                      "org_sky_LibrarianNotes"
                                    )
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        ) : (
                          <Grid item xs={6}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.org_sky_LibrarianNotes ||
                                      specific_updates.org_sky_LibrarianNotes ==
                                      "") &&
                                    editing?.org_sky_LibrarianNotes !==
                                    specific_updates.org_sky_LibrarianNotes &&
                                    !(
                                      editing?.org_sky_LibrarianNotes ==
                                      undefined &&
                                      specific_updates.org_sky_LibrarianNotes ==
                                      ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_LibrarianNotes"
                                  name="org_sky_LibrarianNotes"
                                  title="Librarian Notes"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  maxLength={bulkEditTextLength.LARGE}
                                  isAppend={true}
                                  multiline
                                  rows={6}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    !editTrackAppendValues
                                      ? trackLibrarianNotesAppendFalse !== null
                                        ? trackLibrarianNotesAppendFalse
                                        : ""
                                      : editing &&
                                        editing.org_sky_LibrarianNotes !==
                                        undefined
                                        ? editing.org_sky_LibrarianNotes !== null
                                          ? editing.org_sky_LibrarianNotes
                                          : ""
                                        : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_LibrarianNotes ||specific_updates.org_sky_LibrarianNotes =="")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues(
                                      "org_sky_LibrarianNotes"
                                    )
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        )}
                        
                        {editTrackAppendValues ? (
                          <Grid item xs={12}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.org_sky_Lyrics ||
                                      specific_updates.org_sky_Lyrics == "") &&
                                    editing?.org_sky_Lyrics !==
                                    specific_updates.org_sky_Lyrics &&
                                    !(
                                      editing?.org_sky_Lyrics == undefined &&
                                      specific_updates.org_sky_Lyrics == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Lyrics"
                                  name="org_sky_Lyrics"
                                  title="Lyrics"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  isAppend={true}
                                  multiline
                                  rows={6}
                                  maxLength={bulkEditTextLength.LARGE}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    editTrackAppendValues
                                      ? trackLyrics !== null
                                        ? trackLyrics
                                        : ""
                                      : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Lyrics ||specific_updates.org_sky_Lyrics == "")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues("org_sky_Lyrics")
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        ) : (
                          <Grid item xs={12}>
                            <div
                              className={
                                editTrackAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock flexBasis fullwidth",
                                  specific_updates &&
                                    (specific_updates.org_sky_Lyrics ||
                                      specific_updates.org_sky_Lyrics == "") &&
                                    editing?.org_sky_Lyrics !==
                                    specific_updates.org_sky_Lyrics &&
                                    !(
                                      editing?.org_sky_Lyrics == undefined &&
                                      specific_updates.org_sky_Lyrics == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Lyrics"
                                  name="org_sky_Lyrics"
                                  title="Lyrics"
                                  titleClass={classes.bulkLabelTop}
                                  type={bulkEditTextType.TEXT}
                                  isAppend={true}
                                  multiline
                                  rows={6}
                                  maxLength={bulkEditTextLength.LARGE}
                                  classes={classes}
                                  handleChange={(event) =>
                                    handleTrackValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  value={
                                    !editTrackAppendValues
                                      ? trackLyricsAppendFalse !== null
                                        ? trackLyricsAppendFalse
                                        : ""
                                      : editing &&
                                        editing.org_sky_Lyrics !== undefined
                                        ? editing.org_sky_Lyrics !== null
                                          ? editing.org_sky_Lyrics
                                          : ""
                                        : ""
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Lyrics ||specific_updates.org_sky_Lyrics == "")?false:true}
                                  refreshOnClick={() =>
                                    handleTrackRefreshValues("org_sky_Lyrics")
                                  }
                                  errors={trackSpecificValidation}
                                />
                              </div>
                            </div>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
            </Paper>
          ) : (
            <label className={classes.albumNotAvailable}>
              The current track is not yet available for use, so you can't edit
              it at the moment.
            </label>
          )}
        </>
      </div>
    );
  }
}

export default TracksSingleSpecificUpdates;
